{
  "11a6767d5674c7e4": "Hecho",
  "19766ed6ccb2f4a3": "Cancelar",
  "4a101ec79a35b0a2": "Enviar comentarios",
  "4d3f06fccd60a383": "Agradecemos que te tomes el tiempo para ayudarnos a mejorar.",
  "6d62dfbd9b4caa21": "Comparte tus comentarios",
  "814f4ed2d5bd33e3": "Contactar soporte",
  "85ffb01c5394bf41": "Gracias por tus comentarios",
  "a7e56c38fbd8c267": "Cuéntanos más...",
  "af015af1fd67fbdf": "Lamentamos escuchar eso",
  "f05abe0730c3b196": "Háganos saber cómo podemos mejorar."
}
